import { Grid, Box } from '@mui/material'
import { Typography } from '@nwh-consumer-digital/nw-component-lib'

const thirteenToSeventeenPageFive = (props) => {
  return (
    <Box>
      <Grid container direction="column" justifyContent="space-between" alignItems="left">
        <Grid item xs={12}>
          <img src="/images/Check.png" className="imgAlign"></img>
          <Typography variant="h1" style={{ marginTop: 80, marginBottom: 16 }} className="imgAlign noPad">
            Success!
          </Typography>
        </Grid>
        <Grid item xs={12} s={12} md={12}>
          <Typography type="body" size="large" weight="light">
            {' '}
            Please expect an invite with instructions on how to create your Authorized Individual account within the
            next 5 days.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  )
}
export default thirteenToSeventeenPageFive
